import { Component, OnInit } from '@angular/core';

import { DropEvent } from "ng-drag-drop";
import { Router, ActivatedRoute } from '@angular/router';//to be deleted



import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: "casts",
  templateUrl: "./casts.component.html",
  styleUrls: ["./casts.component.css"]
})
export class CastsComponent implements OnInit {

  //implementing the feedback message at the end of the game
  message: "Try again";
  readMore = "Read more about Casts";
  showMessage = false;

  public show: boolean = false;
  public hide: boolean = true;

  constructor(private router: Router, private r: ActivatedRoute, public ngxSmartModalService: NgxSmartModalService) {
    // this.restartGame();
  }

  ngOnInit() {
  }


  /* SCOPE - CATEGORIES*/
  brahmin = [{ name: "Brahmin", type: "brahmin" }];
  chettri = [{ name: "Chettri", type: "chettri" }];
  janajati = [{ name: "Janajati", type: "janajati" }];
  dalit = [{ name: "Dalit", type: "dalit" }];

  droppedBrahmin = [];
  droppedChettri = [];
  droppedJanajati = [];
  droppedDalit = [];
  droppedItems = [];
  dragEnabled = true;
  dragHint = `<i class="fa fa-hand-pointer-o" aria-hidden="true"></i>`;
  placeholder: any;

  /* DRAG & DROP + REMOVING THE DRAGGED ITEM*/

  onAnyDrop(e: DropEvent) {
    this.droppedItems.push(e.dragData);

    if (e.dragData.type === "brahmin") {
      this.removeItem(e.dragData, this.brahmin);
      this.droppedBrahmin.push(e.dragData);
      console.log(this.brahmin.length);
    }
    if (e.dragData.type === "chettri") {
      this.removeItem(e.dragData, this.chettri);
      this.droppedChettri.push(e.dragData);
      console.log(this.chettri.length);
    }
    if (e.dragData.type === "janajati") {
      this.removeItem(e.dragData, this.janajati);
      this.droppedJanajati.push(e.dragData);
      console.log(this.janajati.length);
    }

    if (e.dragData.type === "dalit") {
      this.removeItem(e.dragData, this.dalit);
      this.droppedDalit.push(e.dragData);
      console.log(this.dalit.length);
    }
    //condition to display the "try again/read more button"
    if (this.brahmin.length === 0 && this.chettri.length === 0 && this.janajati.length === 0 && this.dalit.length === 0) {
      this.showMessage = true;
    }
  }

  removeItem(item: any, list: Array<any>) {
    let index = list
      .map(function (e) {
        return e.name;
      })
      .indexOf(item.name);
    list.splice(index, 1);
  }


  // restartGame() {
  //   this.router.navigateByUrl('/casts');
  //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
  //     return false;
  //   };
  // };
}
